lmApp
  .service('CatchupService', ['$rootScope', '$q',
    function ($rootScope, $q) {

      var service = {};

      service.GetCatchup2References = function (event) {
        var deferred = $q.defer();

        var url = 'catchup2/programs/' + event.program_id;

        lh.common.request(url)
          .then(function (result) {
            deferred.resolve(result);
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.SetCatchup2References = function (event, frame) {
        var deferred = $q.defer();

        var url = 'catchup2/programs/' + event.program_id + '/references';

        var data = {
          reference_url: frame
        };

        lh.common.request.post(url, data)
          .then(function (result) {
            deferred.resolve(result);
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.GetCatchup2Events = function (_ids) {
        var deferred = $q.defer();

        var url = 'catchup2/events';

        var data = {
          event_id: _ids.join(',')
        };

        lh.common.request.get(url, data)
          .then(function (result) {
            deferred.resolve(result.events);
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.GetCatchup2Preview = function (event) {
        var deferred = $q.defer();

        var url = 'catchup2/events/' + event.id;

        lh.common.request(url)
          .then(function (result) {
            deferred.resolve(result);
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.CreateCatchup2Preview = function (event) {
        var deferred = $q.defer();

        var url = 'catchup2/events/' + event.id + '/preview';

        lh.common.request.post(url)
          .then(function (collection) {
            deferred.resolve(collection);
          }, function (reason) {
            reason.url = url;
            reason.data = 'GET';
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.DeleteCatchup2ReferenceImg = function (event, reference) {
        var deferred = $q.defer();

        var url = 'catchup2/programs/' + event.program_id + '/references/' + reference.id;

        lh.common.request.del(url)
          .then(function (result) {
            deferred.resolve(result);
          }, function (reason) {
            reason.url = url;
            reason.data = 'DELETE';
            deferred.reject(reason)
          });

        return deferred.promise;
      };

      service.GetCatchup2PreviewMedia = function (event, preview) {
        var url = '/discovery:80/catchup2/events/' + event.id +
          '/preview/' + preview.id +
          '/media?auth_token=' + encodeURIComponent($rootScope.isSuperuser() ? $rootScope.globals.currentUser.operatorToken : $rootScope.globals.currentUser.token);

        return url;
      };

      service.GetCatchup2ReferenceFromMedia = function (event, preview, position) {
        var url = '/discovery:80/catchup2/events/' + event.id +
          '/preview/' + preview.id +
          '/frame?position=' + position +
          '&auth_token=' + encodeURIComponent($rootScope.isSuperuser() ? $rootScope.globals.currentUser.operatorToken : $rootScope.globals.currentUser.token);

        return url;
      };

      service.GetCatchup2ReferenceImg = function (event, reference) {
        var url = '/discovery:80/catchup2/programs/' + event.program_id +
          '/references/' + reference.id +
          '/media' +
          '?auth_token=' + encodeURIComponent($rootScope.isSuperuser() ? $rootScope.globals.currentUser.operatorToken : $rootScope.globals.currentUser.token);

        return url;
      };

      service.GetCatchup2ThumbnailImg = function (event, preview, index) {
        var url = '/discovery:80/catchup2/events/' + event.id +
          '/preview/' + preview.id +
          '/thumbnails?auth_token=' + encodeURIComponent($rootScope.isSuperuser() ? $rootScope.globals.currentUser.operatorToken : $rootScope.globals.currentUser.token);
        //+'&index=' + index;
        return url;
      };

      return service;
    }]);
